import {
  ExporOrderListSortField,
  ExporOrderListUrlQueryParams
} from "@saleor/changeOrderExport/urls";
import {
  ExportOrderQueryParams,
  ExportOrderSortField
} from "@saleor/createOrderExport/urls";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { RouteComponentProps } from "react-router";

import OrderProcessing from "./views/OrderProcessing";
import Orders from "./views/Orders";
import ViewEditOrder from "./views/ViewEditOrder";

export const OrderListView: React.FC<RouteComponentProps<any>> = () => {
  const qs = parseQs(location.search.substr(1));
  const params: ExporOrderListUrlQueryParams = asSortParams(
    qs,
    ExporOrderListSortField,
    ExporOrderListSortField.piNo
  );
  return <Orders params={params} />;
};

export const ChangeOrderView: React.FC<RouteComponentProps<any>> = ({
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: ExportOrderQueryParams = asSortParams(
    qs,
    ExportOrderSortField,
    ExportOrderSortField.item_no
  );
  return (
    <ViewEditOrder id={decodeURIComponent(match.params.id)} params={params} />
  );
};

export const OrderProcessingView: React.FC<RouteComponentProps<any>> = () => {
  const params = parseQs(location.search.substr(1));

  return <OrderProcessing params={params} />;
};
